import { render, staticRenderFns } from "./SroItem.vue?vue&type=template&id=34c5009e&scoped=true"
import script from "./SroItem.vue?vue&type=script&lang=js"
export * from "./SroItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5009e",
  null
  
)

export default component.exports